import { render, staticRenderFns } from "./EditMUP2Dialog.vue?vue&type=template&id=4f492516&scoped=true"
import script from "./EditMUP2Dialog.vue?vue&type=script&lang=ts"
export * from "./EditMUP2Dialog.vue?vue&type=script&lang=ts"
import style0 from "./EditMUP2Dialog.vue?vue&type=style&index=0&id=4f492516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f492516",
  null
  
)

export default component.exports